<template>
    <div class="imgViewer">

<!--         <div style="position:fixed:top:200px;left:200px;width:300px;color:#fff;font-size:14px;">
            {{hsData}}
        </div>
 -->
        <div class="imgElement" style="z-index: 10;">
            
            <img :src="imgData.src " />            
            <!-- {{contentID}} -->            
            <!-- {{sectionData}} -->
            <!-- image element -->
            <!-- <img src="contents/img/_test.png" /> -->
        </div>

        <div class="imgContents" style="z-index: 50;">
            <div class="itemTitles" id="titles1">
                <!-- insert titles here -->
                <button v-for="(item,index) in imgData.hotspots" 
                    @click="openHotspot(index)"
                    :style="getBtnStyle(index)" 
                    :key="item.title" 
                    :class="['label',itemExpended == index ? 'expended':'',item.title_location=='left' ? '__leftArea':'__rightArea']" 
                    :id="'btn'+index">
                    <div class="title">
                        {{item.title}}
                        <span v-if="item.desc && item.desc.length>1" class="tog">+</span>
                    </div>
                    <div class="desc" v-if="item.desc && item.desc.length>1">
                        {{item.desc}}
                    </div>
                </button>
            </div>

            <svg class="lineContainer visible" id="lines" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">                
                <line v-for="(item,index) in hsData" 
                    :key="'line_'+index"
                    :style="'--index:'+index"
                    :x1 = "item.x1"
                    :y1 = "item.y1"
                    :x2 = "item.x2"
                    :y2 = "item.y2"
                    class="line">
                </line>                
                <!--
                <line class="line" style="--index:0" id="line_0" x1="496.41408623429635" y1="189.6379835247234" x2="762.3984375" y2="249.3984375"></line>
                <line class="line" style="--index:1" id="line_1" x1="450.8826172796878" y1="211.1138233363648" x2="221.6015625" y2="249.3984375"></line>
                <line class="line" style="--index:2" id="line_2" x1="410.49269700195646" y1="209.9195612647359" x2="762.3984375" y2="407"></line>
                <line class="line" style="--index:3" id="line_3" x1="503.9741932931456" y1="288.70136861912493" x2="283.6953125" y2="407"></line>
                <line class="line" style="--index:4" id="line_4" x1="410.4530177506267" y1="328.76658359886574" x2="762.3984375" y2="564.59375"></line>
                <line class="line" style="--index:5" id="line_5" x1="418.1182533045621" y1="544.9094897977142" x2="292.6875" y2="564.59375"></line>
                -->
            </svg>                
            <!-- dot lines with info -->            
            <!-- {{imgData}} -->
            <!-- <div class="testBtn">Test Button</div> -->
        </div>
    </div>
</template>

<style>
    .testBtn
    {
        position: relative;
        top: 300px;
        left: 300px;
        background-color: blue;
        color: #fff;
        padding: 20px;
        text-align: center;
        border-radius: 20px;
        font-size: 12px;
        display: inline-block;
    }
    .testBtn:hover
    {
        background-color: rgb(17, 126, 126);
    }
    .imgViewer
    {
      position: relative;
      width: 100vw;
      height: 100vh;
    }
    .imgElement
    {
        width: 100%;height: 100%;
        position: absolute;        
        color: #fff;
        font-size: 10px;        
    }
    .imgElement img
    {
        position: absolute;
        top: 50%;
        left: 50%;
        width: auto;
        height: 50vh;
        z-index: 1000;
        transform: translate(-50%, -50%);        
    }
    .imgContents
    {
        width: 100%;height: 100%;position: absolute;color: #fff;font-size: 10px;        
    }
 
    /* //////// titles ///////// */
    .itemTitles .label
    {
        /* transition: all ease-in-out 0.6s; */
        /* transition-delay: calc(0.6s + (var(--index) * 0.12s)); */
        /* clip-path: inset(0 100% 0 0); */
        border:0;
        background: transparent;
        transform: translateX(-50%);
        position: absolute;
        text-align: left;
        display: block;
        width: 200px;
    }
    .itemTitles .label.leftArea .title
    {
        text-align: right !important;
        float: right;
    }
    .itemTitles .label.rightArea .title
    {
        text-align: left !important;
        float: left;
    }
    .itemTitles .label .title .tog
    {
        position: relative;
        top: 0px;
        right: -5px;
        font-size: 14px;
        color:#fff;
    }
    .itemTitles.visible .label
    {
        /* opacity: 1; */
        animation: flickering 1s;
        animation-delay: calc(0.6s + (var(--index) * 0.12s));;
        clip-path: inset(0 0 0 0);
    }
    .itemTitles .label .content
    {
        position: absolute;
        top: 50px;
        left:0px;
        width: 10vw;
    }
    .itemTitles .label .title
    {
        text-align: left;
        font-size: 18px;
        max-width: 210px;
        color: #16a5e6; 
        display: inline-block;
    }
    .itemTitles .label.expended .desc
    {
        opacity: 1;
    }   
    .itemTitles .label .desc
    {
        text-align: left;
        font-size: 14px;
        width: calc(200px - 32px);  
        color: #fff; 
        padding-top: 5px;
        opacity: 0;
        transition: all ease 0.5s;
        display: block;
    }

    /* //////// Lines ///////// */
    .lineContainer
    {
        pointer-events: none;
        display: block;  
        position: fixed;      
        top: 0px;
        left: 0px;
    }
    .lineContainer .line
    {
        opacity: 0;
        transition: all ease-in-out 1s;
        transition-delay: calc(0.3s + (var(--index) * 0.12s));
        clip-path: inset(0 100% 0 0);
        stroke: #16a5e6;
        stroke-width: 1;
        stroke-dasharray: 2

    }

    .lineContainer.visible .line
    {
        opacity: 1;
        clip-path: inset(0 0 0 0);
    }          

</style>

<script>
export default 
{
    name: "AppImage",
    props: {        
        sectionData:[],
        contentID:''
    },
    data()
    {
        return {       
            hsData:[],     
            imgData:[],
            itemExpended:-1
        }
    },
    computed:
    {

    },
    created()
    {
    },
    destroyed()
    {
        
    },
    mounted()
    {
        this.loadSectionData();
    },
    watch:{
    },
    methods:
    {
        getRandomNum()
        {
            return Math.floor(Math.random() * (1000 - 100 + 1)) + 100;
        },
        updateHotspots()
        {
            var sw = window.innerWidth;
            var sh = window.innerHeight;

            var vm = this;
            vm.hsData = [];

            var titles1 = document.getElementById("titles1");
            let buttonElements = titles1.querySelectorAll(".label");

            //alert("titles1="+titles1);

            var itemIndex = 0;
            for (const hsItemData of vm.imgData.hotspots) 
            {                
                //todo:
                //if button is on the left side then we 
                //use the x1 position + add the <div class="title"> element with 

                var btnElement = buttonElements[itemIndex];
                const rect = btnElement.getBoundingClientRect();
                var tElement = btnElement.querySelector(".title");
                var tX1 = rect.x;
                var tY1 = rect.y;
                const titleRect = tElement.getBoundingClientRect();
                if(hsItemData.title_location=="left"){                    
                    tX1 += titleRect.width+15;
                }else
                {
                    tX1 -= 5;
                }
                tY1 += titleRect.height*0.5;//set point in the middle height of the title

                var offX = Number(hsItemData.offsetX);
                var offY = Number(hsItemData.offsetY);

                //Translae the offset according the screen size (height)
                var tX2 = sh * offX;
                var tY2 = sh * offY;

                //translate the offset from the center of the image:
                //var tX2 = (sw * 0.5) + (sh * offX);
                //var tY2 = (sh * 0.5) + (sh * offY);

                var hsElement = {
                    x1:tX1,
                    y1:tY1,
                    x2:tX2,
                    y2:tY2
                };
                this.hsData.push(hsElement);
                itemIndex++;
            }

            /*
            <svg class="lineContainer visible" id="lines" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">                
                <line v-for="(item,index) in imgData.hotspots" 
                    :key="'line_'+index"
                    :style="'--index:'+index"
                    class="line">
                </line>
                
                <!--
                <line class="line" style="--index:0" id="line_0" x1="496.41408623429635" y1="189.6379835247234" x2="762.3984375" y2="249.3984375"></line>
            */

        },
        openHotspot(index)
        {
            if(index == this.itemExpended)
            {
                this.itemExpended=-1;
            }else{
                this.itemExpended = index;
            }
        },
        getBtnStyle(index)
        {
            var elementData = this.imgData.hotspots[index].style;
            return elementData;
        },
        loadSectionData()
        {
            var vm=this;
            var url = "contents/data/"+this.sectionData.content_id+".json";
            fetch(url, 
            {
                method: "GET",
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                headers: {"Content-Type": "application/json;charset=UTF-8",'Access-Control-Allow-Origin': '*'},
            })
            .then(function(response) { return response.json();})
            .then(function(response)
            {
                vm.imgData = response;
                setTimeout(() => {
                    vm.updateHotspots();    
                }, 1000);
                
            }        
            );
        }
    },
    watch:
    {
        contentID:function(newVal,oldVal)
        {
            this.loadSectionData();
        }
    }




};
</script>

